import "./App.css";
import Router from "../src/component/Router";
// import RootContextWrapper from "../src/contexts/rootContext";
// import AppInit from "utils/AppInit";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";

const theme = createTheme({
  typography: {
    fontFamily: `'Inter', sans-serif`,
  },
});

function App() {
  return (
    <div className="h-full">
      <ThemeProvider theme={theme}>
        <CssBaseline />
        {/* <RootContextWrapper> */}
          <Router />
          {/* <AppInit /> */}
        {/* </RootContextWrapper> */}
      </ThemeProvider>
    </div>
  );
}

export default App;
